import TemplatesList from 'app-js/components/TemplatesList/TemplateList';

export default TemplatesList;



// WEBPACK FOOTER //
// ./src/public/js/components/TemplatesList/index.js